import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { contentStatsFetchStateConfig } from "../../../../consts";

export const contentStatsMeta = makeCrudStateReducer(
  contentStatsFetchStateConfig
);
